import { Base64 } from "js-base64";

// Universities with different total steps
const universities = [
  {
    university: "iimv",
    total_steps: 5,
  },
  {
    university: "iimt",
    total_steps: 5,
  },
  {
    university: "iitg",
    total_steps: 6,
  },
  {
    university: "xlri",
    total_steps: 4,
  },
  {
    university: "spjain",
    total_steps: 5,
  },
  {
    university: "iith",
    total_steps: 5,
  },
  {
    university: "iiml",
    total_steps: 5,
  },
  {
    university: "unknown",
    total_steps: 1,
  },
];

// Function to get total steps for a university
export const getTotalSteps = (university) => {
  const uni = universities.find((u) => u.university === university);
  return uni ? uni.total_steps : 1; // Fallback to 1 to prevent division by zero
};

export function formatDate(dateString) {
  // Convert the date string to a Date object
  const date = new Date(dateString);

  // Format date to "12 September 2024" in Indian time zone
  const formattedDate = new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

  return formattedDate;
}

// Function to group applications based on their completion status
export const groupApplicationsByStatus = (applications, categories) => {
  const groupedData = {
    ongoing: [],
    completed: [],
  };

  applications.forEach((app) => {
    // Add vertical label from categories
    const categoryData = categories.find((cat) =>
      cat.category.includes(app.category)
    );
    app.vertical = categoryData?.label || "Unknown";

    const totalSteps = getTotalSteps(app.university);

    // Custom logic:
    // If step is exactly the total and status is complete => completed
    if ((app.step === totalSteps && app.step_status === "complete") || (['xlri', 'iitk'].includes(app.university) && app.step_status === "complete")) {
      groupedData.completed.push(app);
    } else {
      groupedData.ongoing.push(app);
    }
  });

  return groupedData;
};


export const encodeBase64 = (base64String) => {
  try {
    let encodedString = Base64.encode(base64String);

    return encodedString;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};

export const paymentPortalRedirectionURL = (university, application_id) => {
  const updatedUniversity = university === 'iimt' ? "iim-trichy" : university
  const url =
    process.env.REACT_APP_NODE_ENV === "development"
      ? `http://localhost:5173`
      : `https://${updatedUniversity}.accredian.com`;

  return `${url}/?app_id=${encodeBase64(application_id)}`;
}

export const decodeJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Failed to decode JWT:", error);
    return null;
  }
};

export const handleLogout = (domain = "accredian.com") => {
  document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`;
  localStorage.clear();
  window.location.href = "https://accredian.com";
};

export const generateApiKey = () => {
  // 🔐 Generate secure timestamp key
  const secretKey = process.env.REACT_APP_AUTH_SHARED_SECRET;
  const randomKey = Math.random().toString(36).substring(2, 12);
  const timestamp = Date.now().toString();
  const rawKey = `${secretKey}:${randomKey}:${timestamp}`;
  const encodedKey = btoa(rawKey); // Base64 encode
  return encodedKey;
};
